// extracted by mini-css-extract-plugin
export default {"tooltip":"VQ-z","arrow":"WQ-z"};